module.exports = __webpack_public_path__ + "img/glass-whiskey.5a6230fd.svg";